import { Form, Switch, Tooltip } from 'antd';
import React from 'react';

const ActivitySwitch = ({
  isActivityDisabled,
  customText,
}: {
  isActivityDisabled: boolean;
  customText?: string;
}): JSX.Element => {
  if (isActivityDisabled) {
    return (
      <Tooltip
        title="Nie można zmienić widoczności gdyż ten element jest aktualnie używany"
        placement="right"
      >
        <Form.Item
          name="isActive"
          label={customText || 'Widoczność'}
          valuePropName="checked"
          style={{
            width: 100,
          }}
        >
          <Switch disabled />
        </Form.Item>
      </Tooltip>
    );
  }
  return (
    <Form.Item
      name="isActive"
      label={customText || 'Widoczność'}
      valuePropName="checked"
    >
      <Switch />
    </Form.Item>
  );
};
export default ActivitySwitch;
